import cx from "classnames";
import { Icon } from "common/Icon";
import { Distance, Duration, Elevation } from "common/units";
import { commonMetrics } from "lib/localization";
import { immutableSumBy } from "lib/utils";
import PropTypes from "prop-types";
import React from "react";
import styles from "./WeekMetaCell.scss";

export class WeekMetaCell extends React.PureComponent {
  static propTypes = {
    trips: PropTypes.object.isRequired,
  };

  render() {
    const { intl, trips } = this.props;

    const miles = immutableSumBy(trips, (t) => t.distance);
    const elevationGain = immutableSumBy(trips, (t) => t.elevationGain);
    const calories = immutableSumBy(trips, (t) => t.calories);
    const movingTime = immutableSumBy(trips, (t) => t.movingTime);

    return (
      <div className={styles.WeekMetaCell}>
        {trips.size > 0 && (
          <div className={styles.cellPadding}>
            <div className={cx(styles.metaBackground, styles.metaData)}>
              <div>
                <span className={styles.value}>
                  <Distance short valueOnly value={miles} />
                </span>{" "}
                <Distance short labelOnly value={miles} />
              </div>
              <div>
                <span className={styles.value}>
                  <Elevation short valueOnly value={elevationGain} />
                </span>{" "}
                <Elevation short labelOnly value={elevationGain} />
              </div>
              <div>
                <span className={styles.value}>{calories}</span> {intl.formatMessage(commonMetrics.calories)}
              </div>
              <div>
                <span className={styles.value}>
                  <Duration short valueOnly value={movingTime} />
                </span>{" "}
                <Duration labelOnly short value={movingTime} />
              </div>
            </div>
          </div>
        )}
        {trips.length === 0 && (
          <div className={styles.placeholder}>
            <Icon i="md-stats" size={28} data-tip title="No stats to show" />
          </div>
        )}
      </div>
    );
  }
}
